import { useEffect } from "react";

export default function useCustomFavicon(reference) {
  useEffect(() => {
    if (!reference) return;

     setTimeout(() => {
            
         const favicon = `/customizations/${reference}/favicon.ico`;

         // 1️⃣ rimuove QUALSIASI favicon esistente
         const existingLinks = document.querySelectorAll(
            "link[rel='icon'], link[rel='shortcut icon'], link[rel='apple-touch-icon']"
         );

         existingLinks.forEach(link => link.remove());

         // 2️⃣ crea SEMPRE un link nuovo e pulito
         const link = document.createElement("link");
         link.rel = "icon";
         link.type = "image/x-icon";
         link.href = `${favicon}?v=${reference}`; // cache-busting 🔥

         document.head.appendChild(link);

         // 3️⃣ cleanup per React strict / unmount
         return () => {
            link.remove();
         };
     }, 2000);
  }, [reference]);
}
